import Image from "next/image";

type NumbersProps = {
  sections: {
    title?: string;
    imageUrl?: string;
    content: string;
    width?: number;
    height?: number;
  }[];
  bgColor?: string;
};

const Numbers = ({ sections, bgColor }: NumbersProps) => {
  return (
    <div
      className="z-1 relative w-full px-4 @container @2xl:px-10 @3xl:px-20 lg:px-6"
      style={{ backgroundColor: bgColor }}
    >
      <section className="mx-auto px-0 py-8 @3xl:max-w-[1280px] lg:px-2 lg:py-12">
        <div className="grid grid-cols-2 grid-rows-2 justify-center gap-2 text-center align-middle @2xl:justify-between @3xl:grid-cols-4 @3xl:gap-4 md:grid-rows-1 md:gap-6">
          {sections.map((section, index: number) => (
            <article className="grid h-full self-center text-center align-middle [text-wrap:balance]" key={index}>
              {!!section.title && (
                <p className="font-matter text-base font-medium leading-none text-primary-700 [text-wrap:balance] lg:text-lg">
                  {section.title}
                </p>
              )}
              <div className="flex flex-grow flex-col items-center justify-between">
                {!!section.imageUrl && (
                  <div className="relative flex items-center justify-center">
                    <Image
                      src={section.imageUrl}
                      alt={section.title || ""}
                      width={section.width || 100}
                      height={section.height || 100}
                      quality={80}
                    />
                  </div>
                )}
                <p className="mb-2 items-end px-2  pt-1 align-bottom text-sm text-primary-700  [text-wrap:balance]  md:px-4 lg:text-base 2xl:px-12">
                  {section.content}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Numbers;
